module.exports = __webpack_public_path__ + "tz.svg?206592dc6556e3cddf82e5f59dbcef24";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/tz.svg
// module id = 1667
// module chunks = 0